import { AttributionsComponent } from './attributions/attributions.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ElsComponent } from './els.component';
import { HomeComponent } from './home/home.component';
import { PageNotFoundComponent } from '../shared/not-found.component';
import { LoginComponent } from '../shared/login/login.component';
import { AuthGuard } from '../shared/auth-guard.service';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { LicenceComponent } from './licence/licence.component';
import { ExploreMapComponent } from './explore-map/explore-map.component';
import { AccessDataComponent } from './access-data/access-data.component';
import { DatasetsComponent } from './datasets/datasets.component';
import { FrequentlyAskedQuestionsComponent } from './frequently-asked-questions/frequently-asked-questions.component';
import { AccessibilityComponent } from './accessibility/accessibility.component';

const appRoutes: Routes = [
  {
    path: '',
    component: ElsComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'datasets/:mapServiceSlug',
        component: DatasetsComponent,
      },
      {
        path: 'explore-map',
        component: ExploreMapComponent,
      },
      {
        path: 'attributions',
        component: AttributionsComponent,
      },
      {
        path: 'explore-map/:mapServiceSlug',
        component: ExploreMapComponent,
      },
      {
        path: 'access-data',
        component: AccessDataComponent,
      },
      {
        path: 'accessibility',
        component: AccessibilityComponent,
      },
      {
        path: 'about',
        component: AboutComponent,
      },
      {
        path: 'frequently-asked-questions',
        component: FrequentlyAskedQuestionsComponent,
      },
      {
        path: 'terms-conditions',
        component: TermsConditionsComponent,
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'contact',
        component: ContactComponent,
      },
      {
        path: 'licence',
        component: LicenceComponent,
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
      },
    ],
  },
  {
    // Lazy Load admin module
    path: 'admin',
    loadChildren: () => import('../shared/admin/admin.module').then((m) => m.AdminModule),
    canLoad: [AuthGuard],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingElsModule {}
